import React from 'react';
import { Helmet } from "react-helmet";
import { FaCode, FaMobileAlt, FaCloud, FaShieldAlt } from 'react-icons/fa';
import './AppSoftware.css';

const AppSoftware = () => {
  return (
    <main className="service-page">
      <Helmet>
        <title>App & Software Engineering | Skyline Bussiness Solution</title>
        <meta name="description" content="Custom enterprise software, mobile apps, and cloud-native solutions engineered by Skyline Bussiness Solution at skylinebussinesssolutions.com." />
        <link rel="canonical" href="https://skylinebussinesssolutions.com/app-software" />
      </Helmet>

      {/* 1. SECTION HERO */}
      <header className="service-hero">
        <div className="service-hero-content">
          <span className="service-badge">CORE CAPABILITIES</span>
          <h1 className="service-display">
            Application <br />
            <span className="accent-text">Software Engineering</span>
          </h1>
          <p className="service-intro">
            At <strong>Skyline Bussiness Solution</strong>, we architect scalable digital 
            ecosystems that automate complexity and drive enterprise velocity.
          </p>
        </div>
      </header>

      <div className="service-container">
        {/* 2. FEATURE GRID */}
        <section className="capabilities-grid">
          <div className="glass-card">
            <FaCode className="card-icon" />
            <h3>Custom Enterprise Software</h3>
            <p>Bespoke solutions tailored to your unique operational workflows and business logic.</p>
          </div>

          <div className="glass-card">
            <FaMobileAlt className="card-icon" />
            <h3>Mobile & Web Apps</h3>
            <p>High-performance cross-platform applications with seamless user experiences.</p>
          </div>

          <div className="glass-card">
            <FaCloud className="card-icon" />
            <h3>Cloud-Based CRM & ERP</h3>
            <p>Centralized management systems designed for global accessibility and data integrity.</p>
          </div>

          <div className="glass-card">
            <FaShieldAlt className="card-icon" />
            <h3>Security & Maintenance</h3>
            <p>Proactive monitoring and hardened security protocols to protect your digital assets.</p>
          </div>
        </section>

        {/* 3. WHY CHOOSE US */}
        <section className="why-section">
          <div className="why-header">
            <h2>Why Skyline Bussiness Solution?</h2>
            <div className="line"></div>
          </div>
          
          <div className="why-grid">
            <div className="why-item">
              <h4>Modern Stack</h4>
              <p>We leverage React, Node.js, and Cloud-native architectures.</p>
            </div>
            <div className="why-item">
              <h4>Scalability First</h4>
              <p>Our codebases are built to grow from 100 to 1,000,000 users.</p>
            </div>
            <div className="why-item">
              <h4>Global Support</h4>
              <p>24/7 technical oversight for mission-critical applications.</p>
            </div>
          </div>
        </section>
      </div>

      {/* SCHEMA */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "App & Software Development",
          "provider": {
            "@type": "Organization",
            "name": "Skyline Bussiness Solution",
            "url": "https://skylinebussinesssolutions.com"
          },
          "description": "High-end enterprise software development including CRM, ERP, and Mobile Applications."
        })}
      </script>
    </main>
  );
};

export default AppSoftware;